$shm_hitalama_map_widget_float_code_textarea $shm_hitalama_textarea
	lazy_enabled true
	attr *
		^
		shm_hitalama_map_widget_float_code_textarea_pending <= reveal_pending false
		aria-busy <= reveal_pending
	auto /
		^
		<= reveal_watch null
